import { useEffect, useState } from "react";
import type { AnimalItem } from "../mocks/animals";
import {
  getAnimals,
  rehydrateAnimals,
  setAllAnimals,
  setAnimals,
  subscribeAnimals,
  updateAnimalById,
} from "../store/animalsStore";

export function useAnimals() {
  const [animals, setAnimalState] = useState<AnimalItem[]>(() => getAnimals());

  useEffect(() => {
    void rehydrateAnimals();

    const unsubscribe = subscribeAnimals(() => {
      setAnimalState(getAnimals());
    });

    setAnimalState(getAnimals());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    animals,
    setAllAnimals,
    setAnimals,
    updateAnimalById,
  };
}